import { createContext, type Dispatch, type SetStateAction } from 'react';

interface GoodsDetailContextType {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  animateTitle: (wrapperYPosition?: number) => void;
}

const GoodsDetailContext = createContext({} as GoodsDetailContextType);

export { GoodsDetailContext, type GoodsDetailContextType };
